import { View } from './view'

export const SignFormSection = View
